import { createContext, useContext, useEffect, useState } from "react";
import backofficeAxiosInstance from "../api/backoffice.api";

const LotterySettingsContext = createContext(null);

export const LotterySettingsProvider = ({ children }) => {

  const [loading, setLoading] = useState(true);
  const [lotterySettings, setLotterySettings] = useState({
    sellingOrder: "ASC",
    numberOfSlots: 12,
    pushToPos: true,
  });

  const [globalPackOrder, setGlobalPackOrder] = useState("ASC");
  const fetchLotterySettings = async () => {
    try {
      setLoading(true);

      const res = await backofficeAxiosInstance.get("/lottery/settings");

      if (res.data) {

        const settings = {
          sellingOrder: res.data.sellingOrder || "ASC",
          numberOfSlots: res.data.numberOfSlots ?? 12,
          pushToPos: res.data.pushToPos ?? true,
        };

        setLotterySettings(settings);
        setGlobalPackOrder(settings.sellingOrder);
      }

    } catch (error) {
      console.error("Failed to fetch lottery settings", error);
    } finally {
      setLoading(false);
    }
  };

  const updateLotterySettings = async (payload) => {
    try {

      const res = await backofficeAxiosInstance.put("/lottery/settings",payload);

      if (res.data?.success)
        await fetchLotterySettings();

      return res;

    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    fetchLotterySettings();
  }, []);

  return (
    <LotterySettingsContext.Provider
      value={{
        loading,

        // full settings
        lotterySettings,
        setLotterySettings,

        // legacy field (already used in your app)
        globalPackOrder,
        setGlobalPackOrder,

        // actions
        refetchLotterySettings: fetchLotterySettings,
        updateLotterySettings,
      }}
    >
      {children}
    </LotterySettingsContext.Provider>
  );
};

// 🔹 Hook
export const useLotterySettings = () => {
  const ctx = useContext(LotterySettingsContext);

  if (!ctx) {
    throw new Error(
      "useLotterySettings must be used inside LotterySettingsProvider"
    );
  }

  return ctx;
};
